export const routePath = {
  
    login: "/login",
    
    // --------------------
    main: "/main",
    home: "/home",
    dashboard: "dashboard",
    billing:"billing",
    tableView:"tableView",
    user:"user",
    role:"role",
    table:"table",
    tableDetail:"tableDetail",
    discount:"discount",
    inventory:"inventory",
    inventorycost:"inventorycost",
    profile:"myprofile",
      resetpassword:"resetpassword",
       report:"report",
       reportview:"reportview"
  };
  